export default "__VITE_ASSET__CyXqOHMz__"